import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {inject, Injectable} from '@angular/core';

import {environment} from "@numizmat/environments";
import {
  ProfileConversationResponse,
  FilterProfileConversationsRequest,
  FilterProfileConversationsResponse,
  DeleteGroupProfileConversationsRequest
} from "@numizmat/services-models/core";

@Injectable({
  providedIn: 'root'
})
export class ProfileConversationApiService {
  private httpClient: HttpClient = inject(HttpClient);

  private profileConversationController: string = 'profileConversation';

  public getAllProfileConversations(): Observable<ProfileConversationResponse[]> {
    const endpoint = `${environment.apiCoreUrl}/${this.profileConversationController}/all`;
    return this.httpClient.get<ProfileConversationResponse[]>(endpoint);
  }

  public deleteProfileConversation(conversationUserId: string): Observable<number> {
    const endpoint = `${environment.apiCoreUrl}/${this.profileConversationController}/${conversationUserId}`;
    return this.httpClient.delete<number>(endpoint);
  }

  public deleteGroupProfileConversations(request: DeleteGroupProfileConversationsRequest): Observable<number> {
    const endpoint = `${environment.apiCoreUrl}/${this.profileConversationController}/group/delete`;
    return this.httpClient.post<number>(endpoint, request);
  }

  public filterProfileConversations(request: FilterProfileConversationsRequest): Observable<FilterProfileConversationsResponse> {
    const endpoint = `${environment.apiCoreUrl}/${this.profileConversationController}/filter`;
    return this.httpClient.post<FilterProfileConversationsResponse>(endpoint, request);
  }
}
